export const locale = {
  lang: 'id',
  data: {
    'NAV': {
      'PROJECT': {
        'DASHBOARD': 'Dashboard Proyek',
        'GROUP': 'Manajemen Proyek',
        'TITLE': 'Daftar Proyek',
        'CALENDAR': 'Kalender Kegiatan',
        'ALL': 'Semua Proyek',
        'ONPROGRESS': 'Progress Proyek',
        'PLANNED': 'Rencana',
        'PROGRESS': 'Berlangsung',
        'DONE': 'Selesai',
        'CLOSED': 'Lunas',
        'CANCELED': 'Batal',
        'ONHOLD': 'Ditunda'
      },
      'MONETARY': {
        'GROUP': 'Manajemen Keuangan',
        'MENU': 'Pengaturan Menu',
        'EARNINGS': 'Pendapatan Tahunan',
        'CREDIT': 'Piutang',
        'SUBSCRIPTION': 'Langganan',
        'INVOICE': {
          'LIST': 'Daftar Penagihan',
          'SAVED': 'Penagihan',
          'DRAFT': 'Konsep',
          'RESTORE': 'Pulihkan'
        },
        'PAYMENT': 'Daftar Pembayaran'
      },
      'ASSETS': {
        'GROUP': 'Manajemen Logistik',
        'DASHBOARD': 'Dashboard Aset',
        'APPROVAL': 'Persetujuan Aset',
        'APPROVAL_ADD': 'Penambahan',
        'APPROVAL_RENT': 'Peminjaman',
        'APPROVAL_RETURN': 'Pengembalian',
        'APPROVAL_DISCONTINUE': 'Pemberhentian',
        'APPROVAL_MAINTENANCE': 'Perbaikan',
        'APPROVAL_MAINTENANCE_RETURN': 'Pengembalian Perbaikan',
        'MASTER': 'Daftar Aset',
        'RENTAL': 'Peminjaman Aset',
        'RETURN': 'Pengembalian Aset',
        'DISCONTINUE': 'Pemberhentian Aset',
        'CATEGORY': 'Kategori Aset',
        'MAINTENANCE': 'Perbaikan Aset',
        'CONDITION': 'Kondisi Aset',
      },
      'MASTER': {
        'GROUP': 'Data Induk',
        'COA': 'COA',
        'CUSTOMER': 'Daftar Pelanggan',
        'VENDOR': 'Daftar Vendor',
        'BANK': 'Daftar Rekening Bank',
        'REGIONS': {
          'TITLE': 'Daftar Wilayah',
          'PROVINCE': 'Provinsi',
          'CITY': 'Kabupaten/Kota',
          'DISTRICT': 'Kecamatan',
          'SUBDISTRICT': 'Kelurahan'
        },
        'USERS': {
          'TITLE': 'Daftar Pengguna',
          'ALL': 'Semua Pengguna',
          'PROJECT': 'Bidang Proyek',
          'MONETARY': 'Bidang Keuangan',
          'LOGISTIC': 'Bidang Logistik',
        },
        'JOBPOSITION': 'Daftar Jabatan',
        'PRIVILEGE': 'Daftar Kewenangan',
        'ROLES': 'Grup Akses',
        'ACCESS': 'Hak Akses',
        'PRIVILEGES': 'Hak Istimewa Pengguna',
        'SETTING': {
          'TITLE': 'Pengaturan',
          'COMPANY': 'Profil Perusahaan',
          'SITE': 'Pengaturan Situs',
          'MENU': 'Pengaturan Menu',
          'BACKUP': 'Pencadangan Data'
        },
        'LOGS': {
          'TITLE': 'Daftar Log',
          'SYSTEM': 'Log Sistem',
          'ACTIVITY': 'Log Aktifitas',
        },
      },
    }
  }
};
